import type { RouteMeta } from 'vue-router';

import { adminEnumRoutes } from '@/routes/admin/admin.enum.routes';

export const AdminMenuItems: {
  path: string;
  name: string;
  meta: RouteMeta;
}[] = [
  // KP-60: under `internal-team-mode` there is ONE dashboard. The
  // internalTeam entry is nav-hidden via navHiddenInInternalTeamMode (its
  // page's widgets moved into WatarDashboard, served by the Dashboard
  // route, which is also the default landing — see auth.checkAdminPermission).
  // With the flag off the entry is filtered out by its config gate anyway
  // and the legacy dashboard stays the landing, exactly as before.
  adminEnumRoutes.internalTeam,
  adminEnumRoutes.onboardingSteps,
  adminEnumRoutes.dashboard,
  adminEnumRoutes.users,
  adminEnumRoutes.teams,
  adminEnumRoutes.journeys,
  adminEnumRoutes.courses,
  adminEnumRoutes.LearningCategories,
  adminEnumRoutes.registrationRequest,
  adminEnumRoutes.approvals,
  adminEnumRoutes.grades,
  adminEnumRoutes.socialPlatform,
  adminEnumRoutes.events,
  adminEnumRoutes.transactions,
  adminEnumRoutes.refunds,
  adminEnumRoutes.transferToBankRequest,
  adminEnumRoutes.announcements,
  adminEnumRoutes.newsLetters,
  adminEnumRoutes.articles,
  adminEnumRoutes.wallets,
  adminEnumRoutes.conversionRate,
  adminEnumRoutes.issuedCertificates,
  adminEnumRoutes.assessments,
  adminEnumRoutes.permissions,
  adminEnumRoutes.supportTickets,
  adminEnumRoutes.organizationOverview,
];
